var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"table"},[_c('div',{staticClass:"table-tile"},[_vm._v(_vm._s(_vm.$t('fullDinein.tablenumber')))]),_c('span',{staticClass:"table-content"},[_vm._v(_vm._s(_setup.table))])])
}
var staticRenderFns = []

export { render, staticRenderFns }